import { gql } from '@apollo/client';

export const GET_SIGNED_UPLOAD_URL = gql`
  query GetSignedFileUploadEndpoint($params: SignedFileUploadEndpointInput) {
    getSignedFileUploadEndpoint(params: $params) {
      success
      message
      errors
      data {
        uploadUrl
        uri
        fileName
        mimeType
        path
      }
    }
  }
`;

export const GET_DOCUMENTS_LIST = gql`
  query ChatbotDocuments($params: FindDocumentListInput!) {
    chatbotDocuments(params: $params) {
      success
      message
      errors
      data {
        documents {
          id
          tenantId
          userId
          fileName
          originalFileName
          fileSize
          mimeType
          path
          uri
          description
          tags
          docMetadata
          documentTypeId
          documentType {
            id
            code
            name
            description
            chunkSize
            chunkOverlap
            createdAt
            createdBy
          }
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_DOCUMENT = gql`
  query ChatbotDocument($params: FindDocumentInput!) {
    chatbotDocument(params: $params) {
      success
      message
      errors
      data {
        id
        tenantId
        userId
        fileName
        originalFileName
        fileSize
        mimeType
        path
        uri
        description
        tags
        docMetadata
        documentTypeId
        documentType {
          id
          code
          name
          description
          chunkSize
          chunkOverlap
          createdAt
          createdBy
        }
        createdAt
        createdBy
      }
    }
  }
`;
